import React from 'react';
import StartConsultationCardMobile from './StartConsultationCardMobile';
import StepNumber from './StepNumber';
import DottedLine from './DottedLine';

type Card = {
	step: string | number;
	title: string;
	content: string;
	imgSrc: string;
	imgAlt: string;
	imgSrcMobile?: string;
};

type Props = {
	cards: Card[];
};


const StepsNumbers: React.FC<Props> = ({ cards }) => {
    const numOfSteps = cards.length;
    return (
        <div className="flex flex-col items-center mr-[8px]">
            {Array.from({ length: numOfSteps }).map((_, index) => (
                <div key={index} className="flex flex-col items-center">
                    <StepNumber step={index + 1} />
                    {index < numOfSteps - 1 && (
                        <DottedLine height={108}  />
                    )}
                </div>
            ))}
        </div>
    );
};

export const StartConsultationCardContainerMobile: React.FC<Props> = ({ cards }) => {
	return (
		<div 
			id="cards-container-mobile" 
			className="
				w-full
				flex  
				justify-center 
				items-center 
				px-2 
				md:px-10 
				p-2 
				mt-4
				pb-10
			"
		>
			<StepsNumbers cards={cards} />

            <div 
				id='mobile-cards-container' 
           		className="
					flex-1
					flex
					flex-col  
					justify-start 
					items-start 
					gap-[20px]
					ml-2"
			>
			{cards?.map((card, index) => (
                <div key={index} className="w-full">
					<StartConsultationCardMobile 
						title={card.title} 
						content={card.content} 
						imgSrc={ card.imgSrcMobile || card.imgSrc} 
						imgAlt={card.imgAlt}
                    />
				</div>
			))}
            </div>
		</div>
	);
};

export default StartConsultationCardContainerMobile;
